import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/en/insights/page.tsx");
